import { formatNumberToCurrencyString } from 'utils/number';

const GET_PAYMENT = 100;

export const MonthlyPaymentEstimationType = {
  UB_05: '0.5',
  UB_1: '1',
  UB_5: '5',
  UB_CALC: 'un_calc',
};

export const getMonthlyPaymentEstimationOptions = (
  { months, percent },
  { unpaidBalance, isCalculatedOption },
) => {
  const { UB_05, UB_1, UB_5 } = MonthlyPaymentEstimationType;
  const getPayment = (percent, months = 1) => (unpaidBalance * percent) / GET_PAYMENT / months;

  return [
    {
      name: `${UB_05}% of Unpaid Balance (${formatNumberToCurrencyString(getPayment(UB_05))})`,
      value: UB_05,
      monthlyPayment: getPayment(UB_05),
    },
    {
      name: `${UB_1}% of Unpaid Balance (${formatNumberToCurrencyString(getPayment(UB_1))})`,
      value: MonthlyPaymentEstimationType.UB_1,
      monthlyPayment: getPayment(UB_1),
    },
    {
      name: `${UB_5}% of Unpaid Balance (${formatNumberToCurrencyString(getPayment(UB_5))})`,
      value: MonthlyPaymentEstimationType.UB_5,
      monthlyPayment: getPayment(UB_5),
    },
    {
      name: [
        '% UPB / Months (calculated)',
        isCalculatedOption && !!percent && !!months
          ? `(${formatNumberToCurrencyString(getPayment(percent, months))})`
          : '',
      ].join(' '),
      value: MonthlyPaymentEstimationType.UB_CALC,
      monthlyPayment: getPayment(percent, months),
    },
  ];
};

export const MAX_LOAN_TERM_MONTHS = 9999;
export const MIN_INTEREST_RATE = 0.001;
export const MAX_INTEREST_RATE = 100;
